export { default } from './EnergiaSolarPerguntasFrequentes';
